import React from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import ListPageContainer from "../../Common/jsx/ListPageContainer"
import { getEntitiesUrlParameters } from "../../Common/js/get_entities_url_parameters"
import withHooks from "../../Common/jsx/WithHooks"
import { getStatistics } from "../../api/api_statistic"

class Dashboard extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.headers = {}

    this.state = {
      displayVisibleOnly: true,
      listPagination: {
        statistics: {
          itemsPerPage: 5,
          page: 1,
          totalItems: -1,
          firstPageUrl: "",
          lastPageUrl: "",
          previousPageUrl: "",
          nextPageUrl: "",
        },
      },
      listOrders: {
        statistics: {
          id: "asc",
        },
      },
      statistics: [],
    }

    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)
    this.getHeaders = this.getHeaders.bind(this)
    this.getFilters = this.getFilters.bind(this)
    this.getRows = this.getRows.bind(this)
    this.buildEntity = this.buildEntity.bind(this)
  }

  componentDidMount() {
    this.getEntities()
  }

  getEntities() {
    let parametersStatistics = getEntitiesUrlParameters(this.state.listPagination.statistics, {}, this.state.listOrders.statistics)

    Promise.all([getStatistics(parametersStatistics)]).then((promisesResults) => {
      let [statistics] = promisesResults

      let listPagination = { ...this.state.listPagination }
      listPagination.statistics = {
        ...listPagination.statistics,
        ...{
          totalItems: statistics["hydra:totalItems"],
          pageTypeUrl: statistics["hydra:view"]["@id"],
          firstPageUrl: statistics["hydra:view"]["hydra:first"],
          lastPageUrl: statistics["hydra:view"]["hydra:last"],
          previousPageUrl: statistics["hydra:view"]["hydra:previous"],
          nextPageUrl: statistics["hydra:view"]["hydra:next"],
        },
      }

      this.setState({ isReadyToRender: true, listPagination, statistics: statistics["hydra:member"] })
    })
  }

  getHeaders(listType) {
    switch (listType) {
      case "statistics":
        return [
          {
            name: "id",
            title: this.props.t("form.id"),
            className: "text-center",
            sort: this.state.listOrders.id !== undefined ? this.state.listOrders.id : "",
          },
          {
            name: "creationStr",
            title: this.props.t("form.creation"),
          },
          {
            name: "clientStr",
            title: this.props.t("entity.client"),
          },
          {
            name: "loanPeriodStr",
            title: this.props.t("form.period"),
          },
          {
            name: "actions",
            title: this.props.t("app.actions"),
          },
        ]
    }
  }

  getFilters(listType) {}

  buildEntity(entity, entityType) {}

  getRows(entityType) {
    return this.state[entityType].map((entity) => {
      entity = this.buildEntity(entity, entityType)
      this.dMgr.debug("built entity:", entity)

      let fields

      this.dMgr.debug("built ssqq:", fields)

      return {
        entity: entity,
        fields: fields,
      }
    })
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <>
        <br />
        <Container fluid>
          <Row>
            <Col md={2}>
              <Card bg="dark" text="white" className="box-shadow-lvl3">
                <Card.Body>
                  ADMIN DASHBOARD
                  {/* <div className="card-entity-title">{this.props.t("app.quick_actions")}</div>
                  <br />
                  <div className="text-center margin-bottom-10" key={"btn-add-order"}>
                    <Button
                      id={"btn-add-order"}
                      onClick={() =>
                        this.props.router.nav({
                          entitiesType: "orders",
                          actionName: "add",
                          referrerUrl: "/",
                        })
                      }
                      variant="success"
                      size="sm"
                      className="margin-right-5"
                    >
                      {this.props.t("action.add") + " " + this.props.t("entity.order")}
                    </Button>
                  </div> */}
                </Card.Body>
              </Card>
            </Col>
            {/* <Col md={10}>
              <ListPageContainer
                tableName={"list_" + this.props.entitiesType}
                referrerUrl={"/dashboard"}
                noCard
                title={this.props.t("app.loansInProgress")}
                entityType="order"
                entitiesType="orders"
                tableHeaders={this.getHeaders("ordersLoan")}
                tableRows={this.getRows("ordersLoan")}
                filters={this.getFilters("ordersLoan")}
                listPagination={this.state.listPagination.ordersLoan}
                listOrders={this.state.listOrders.ordersLoan}
              />
            </Col> */}
          </Row>
        </Container>
      </>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(Dashboard)
